export default {
  en: {
    master_preference: {
      title: 'Notification emails',
      desc: 'We send notification emails for key events that you should be aware of within your organisation.<br />You may configure what you wish to be notified about below, or turn off all email notifications.',
    },
    connection_request_received: {
      title: 'Connection request received',
      desc: 'When you receive a connection request from another organisation.',
    },
    connection_request_reminder: {
      title: 'Connection request reminder',
      desc: 'Reminders of any pending connection requests from other organisations.',
    },
    connection_request_accepted: {
      title: 'Connection request accepted',
      desc: 'When another organisation accepts a connection request you sent.',
    },
    connection_request_rejected: {
      title: 'Connection request rejected',
      desc: 'When another organisation rejects a connection request you sent.',
    },
    connection_deleted: {
      title: 'Connection removed',
      desc: 'When another organisation removes you as a connection.',
    },
    discussion_created: {
      title: 'New discussion',
      desc: 'When another organisation starts a discussion with you.',
    },
    discussion_comment_created: {
      title: 'Replies to a discussion',
      desc: 'Another organisation replies to one of the discussions they have with your organisation.',
    },
    discussion_reminder: {
      title: 'Discussion reminders',
      desc: 'Reminders when an open discussion requires a reply.',
    },
    emerging_threat_published: {
      title: 'Emerging Threats',
      desc: 'Get notified when Risk Ledger publishes a new Emerging Threat to the network.',
    },
    emerging_threat_reminder: {
      title: 'Emerging Threats reminders',
      desc: 'Get reminders for Emerging Threats your organisation has not responded to yet.',
    },
    invite_accepted: {
      title: 'Invite accepted',
      desc: 'When a supplier accepts your invite to join Risk Ledger.',
    },
    supplier_invite_expired: {
      title: 'Invite expired',
      desc: 'When an invitation to a supplier expires.',
    },
    assessment_completed: {
      title: 'Supplier completes assessment',
      desc: 'When a supplier completes their initial assessment.',
    },
    reapproval_required: {
      title: 'Re-Approval',
      desc: 'Get notified 30 days before a supplier approval expires, as well as when it expires and requires re-approval.',
    },
    weekly_digest_client: {
      title: 'Weekly supplier summary',
      desc: 'A summary of all activity from your suppliers within the past week.',
    },
    assessment_reminder: {
      title: 'Assessment reminders',
      desc: 'Reminders to complete your initial assessment for your clients.',
    },
    reassessment_reminder: {
      title: 'Re-Assessment reminders',
      desc: 'Timely reminders to help you complete your re-assessment.',
    },
    reassessment_reminder_old: {
      title: 'Re-Assessment due',
      desc: 'When your periodic re-assessment is due, to ensure your previous assessment answers are still correct for your clients.',
    },
    remediation_request_received: {
      title: 'Remediation request received',
      desc: 'When a client requests remediation of one of your assessment answers.',
    },
    remediation_request_responded: {
      title: 'Remediation request response',
      desc: 'When a supplier responds to a remediation request.',
    },
    answer_expired: {
      title: 'Answer expiry',
      desc: 'Get notified 30 days before one of your assessment answers expires, as well as when they expire, e.g. certificates with an expiry date.',
    },
    community_post_created: {
      title: 'New posts',
      desc: 'Get notified when there is a new post in your community.',
    },
    community_own_post_reply_created: {
      title: 'New replies',
      desc: 'Get notified when a peer replies to one of your posts.',
    },
    community_replied_post_reply_created: {
      title: 'New replies in conversations',
      desc: 'Get notified when a peer replies to one of the posts you have previously replied to.',
    },
    forClients: 'For clients',
    forSuppliers: 'For suppliers',
    fetchError: 'Failed to fetch notification preferences.',
    fetchRetry: 'Retry',
    updateError: 'Failed to update preference. Please try again.',
    supplierRelatedNotifications: {
      title: 'Supplier related notifications',
      desc: 'Receive notifications from all suppliers in your organisation or only those assigned to you.',
    },
    supplierRelatedNotificationsDropdown: {
      allSuppliers: 'All suppliers',
      assignedSuppliers: 'Assigned suppliers',
    },
    weekly_digest_supplier: {
      title: 'Weekly client summary',
      desc: 'A summary of actions and updates from your clients within the past week.',
    },
  },
};
